<div mat-dialog-title class="d-flex justify-content-between align-items-center">
  <h2 class="m-0">Add/edit member timings</h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content *ngIf="!loader && !editmode">
  <div class="row">
    <div class="col-sm-12">
      <div class="member_profile">
        <div class="bgt_colorkk"></div>
        <img
          [src]="memberDetailsData.image_thumb_url"
          onerror="this.src='../../../../assets/images/user-avatar.svg'"
          alt=""
        />
      </div>
      <div
        style="
          margin-bottom: 30px;
          display: flex;
          align-items: baseline;
          text-decoration: underline;
          justify-content: end;
        "
      >
        <div>
          <span
            class="material-icons icon_mat"
            style="font-size: 20px; top: 5px"
          >
            edit
          </span>
        </div>
        <div style="cursor: pointer" (click)="onEdit()">Edit</div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> person </span>
          </div>
          <div class="entity_detail make_text_grey">Name</div>
        </div>
        <div class="sub_one_cont main_text">
          <div class="entity_detail" style="margin-left: 30px; font-size: 16px">
            {{ memberDetailsData.name }}
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> call </span>
          </div>
          <div class="entity_detail make_text_grey">Phone</div>
        </div>
        <div class="sub_one_cont main_text">
          <div class="entity_detail" style="margin-left: 30px; font-size: 16px">
            {{ memberDetailsData.country_code }} {{ memberDetailsData.phone }}
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> mail </span>
          </div>
          <div class="entity_detail make_text_grey">Email</div>
        </div>
        <div class="sub_one_cont main_text">
          <div class="entity_detail" style="margin-left: 30px; font-size: 16px">
            {{
              memberDetailsData.email
                ? memberDetailsData.email
                : "No email added"
            }}
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> transgender </span>
          </div>
          <div class="entity_detail make_text_grey">Gender</div>
        </div>
        <div class="sub_one_cont main_text">
          <div class="entity_detail" style="margin-left: 34px; font-size: 16px">
            {{ memberDetailsData.gender }}
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> calendar_month </span>
          </div>
          <div class="entity_detail make_text_grey">DOB</div>
        </div>
        <div class="sub_one_cont main_text">
          <div class="entity_detail" style="margin-left: 34px; font-size: 16px">
            {{
              memberDetailsData.dob
                ? (memberDetailsData.dob | date)
                : "No DOB added"
            }}
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> calendar_month </span>
          </div>
          <div class="entity_detail make_text_grey" style="margin-bottom: 8px">
            Membership start date
          </div>
        </div>
        <div class="sub_one_cont main_text">
          <div class="sub_one_cont main_text">
            <div
              class="entity_detail"
              style="margin-left: 34px; font-size: 16px"
            >
              {{ memberDetailsData.membership_start_date | date }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> settings </span>
          </div>
          <div class="entity_detail make_text_grey" style="margin-bottom: 8px">
            Service mode
          </div>
        </div>
        <div class="sub_one_cont main_text">
          <div class="sub_one_cont main_text">
            <div
              class="entity_detail"
              style="margin-left: 34px; font-size: 16px"
            >
              {{ memberDetailsData.s_mode }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> list_alt </span>
          </div>
          <div class="entity_detail make_text_grey" style="margin-bottom: 8px">
            Opted services
          </div>
        </div>
        <div
          class="sub_one_cont main_text"
          *ngIf="memberDetailsData.opted_services"
        >
          <div class="sub_one_cont main_text">
            <div
              class="entity_detail"
              style="margin-left: 34px; font-size: 16px"
            >
              {{ memberDetailsData.opted_services }}
            </div>
          </div>
        </div>
        <div
          class="sub_one_cont main_text"
          *ngIf="!memberDetailsData.opted_services"
        >
          <div class="sub_one_cont main_text">
            <div
              class="entity_detail"
              style="margin-left: 34px; font-size: 16px"
            >
              No opted services
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> list_alt </span>
          </div>
          <div class="entity_detail make_text_grey" style="margin-bottom: 8px">
            Opted products
          </div>
        </div>
        <div
          class="sub_one_cont main_text"
          *ngIf="memberDetailsData.opted_products"
        >
          <div class="sub_one_cont main_text">
            <div
              class="entity_detail"
              style="margin-left: 34px; font-size: 16px"
            >
              {{ memberDetailsData.opted_products }}
            </div>
          </div>
        </div>
        <div
          class="sub_one_cont main_text"
          *ngIf="!memberDetailsData.opted_products"
        >
          <div class="sub_one_cont main_text">
            <div
              class="entity_detail"
              style="margin-left: 34px; font-size: 16px"
            >
              No opted products
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> list_alt </span>
          </div>
          <div class="entity_detail make_text_grey" style="margin-bottom: 8px">
            Other items
          </div>
        </div>
        <div class="sub_one_cont main_text" *ngIf="memberDetailsData.opted_cis">
          <div class="sub_one_cont main_text">
            <div
              class="entity_detail"
              style="margin-left: 34px; font-size: 16px"
            >
              {{ memberDetailsData.opted_cis }}
            </div>
          </div>
        </div>
        <div
          class="sub_one_cont main_text"
          *ngIf="!memberDetailsData.opted_cis"
        >
          <div class="sub_one_cont main_text">
            <div
              class="entity_detail"
              style="margin-left: 34px; font-size: 16px"
            >
              No other items
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="col-md-12"
      *ngIf="memberDetailsData.timings && memberDetailsData.timings != 'null'"
    >
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> work_history </span>
          </div>
          <div class="entity_detail make_text_grey" style="margin-bottom: 8px">
            Opted timings
          </div>
        </div>
        <div class="sub_one_cont main_text">
          <div class="entity_detail" style="margin-left: 30px">
            <mat-chip-list aria-label="sunday">
              <mat-chip *ngFor="let item of memberDetailsData.opted_timings">
                {{ item }}
              </mat-chip>
            </mat-chip-list>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> payments </span>
          </div>
          <div class="entity_detail make_text_grey">Subscription fees</div>
        </div>
        <div class="sub_one_cont main_text">
          <div
            class="entity_detail"
            style="margin-left: 34px; font-size: 16px"
            *ngIf="
              memberDetailsData.membership_fee &&
              memberDetailsData.membership_fee != 'null'
            "
          >
            {{ memberDetailsData.currency_symbol
            }}{{ memberDetailsData.membership_fee.toFixed(2) }}
          </div>
          <div
            class="entity_detail"
            style="margin-left: 34px; font-size: 16px"
            *ngIf="
              !memberDetailsData.membership_fee ||
              memberDetailsData.membership_fee == 'null'
            "
          >
            {{ memberDetailsData.currency_symbol }}0.00
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> payments </span>
          </div>
          <div class="entity_detail make_text_grey">Discount</div>
        </div>
        <div class="sub_one_cont main_text">
          <div
            class="entity_detail"
            style="margin-left: 34px; font-size: 16px"
            *ngIf="
              memberDetailsData.discount && memberDetailsData.discount != 'null'
            "
          >
            {{ memberDetailsData.currency_symbol
            }}{{ memberDetailsData.discount.toFixed(2) }}
          </div>
          <div
            class="entity_detail"
            style="margin-left: 34px; font-size: 16px"
            *ngIf="
              !memberDetailsData.discount ||
              memberDetailsData.discount == 'null'
            "
          >
            {{ memberDetailsData.currency_symbol }}0.00
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> payments </span>
          </div>
          <div class="entity_detail make_text_grey">Net payable</div>
        </div>
        <div class="sub_one_cont main_text">
          <div
            class="entity_detail"
            style="margin-left: 34px; font-size: 16px"
            *ngIf="
              memberDetailsData.net_payable &&
              memberDetailsData.net_payable != 'null'
            "
          >
            {{ memberDetailsData.currency_symbol
            }}{{ memberDetailsData.net_payable.toFixed(2) }}
          </div>
          <div
            class="entity_detail"
            style="margin-left: 34px; font-size: 16px"
            *ngIf="
              !memberDetailsData.net_payable ||
              memberDetailsData.net_payable == 'null'
            "
          >
            {{ memberDetailsData.currency_symbol }}0.00
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> payments </span>
          </div>
          <div class="entity_detail make_text_grey">Notes</div>
        </div>
        <div class="sub_one_cont main_text">
          <div class="entity_detail" style="margin-left: 34px; font-size: 16px">
            {{
              memberDetailsData.notes && memberDetailsData.notes != "null"
                ? memberDetailsData.notes
                : "No notes added"
            }}
          </div>
        </div>
      </div>
    </div>
    <div
      class="col-md-12"
      *ngIf="
        memberDetailsData.billing_period &&
        memberDetailsData.billing_period != 'null'
      "
    >
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> payments </span>
          </div>
          <div class="entity_detail make_text_grey">Billing period</div>
        </div>
        <div class="sub_one_cont main_text">
          <div
            class="entity_detail"
            style="margin-left: 34px; font-size: 16px"
            *ngIf="memberDetailsData.billing_period == 1"
          >
            Weekly
          </div>
          <div
            class="entity_detail"
            style="margin-left: 34px; font-size: 16px"
            *ngIf="memberDetailsData.billing_period == 2"
          >
            Monthly
          </div>
          <div
            class="entity_detail"
            style="margin-left: 34px; font-size: 16px"
            *ngIf="memberDetailsData.billing_period == 3"
          >
            Yearly
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-content *ngIf="editmode">

  <div *ngIf="isEntityIndividual == '1'">
    <div class="chip_cont" *ngFor="let item of selectedDays; let i = index">
      <mat-chip-list
        aria-label="Fish selection"
        class="mb-3 matchp"
        style="
          border-bottom: 1px solid #e2e2e2;
          padding-bottom: 15px;
          width: 100%;
          display: block;
        "
      >
        <div class="close_heradinrt">
          <p style="cursor: pointer" (click)="removeSelectedDay(i)">Remove</p>
        </div>
        <div>
          <mat-chip class="selected" style="height: auto"
            >{{ item.day.dayName }}
          </mat-chip>
          <mat-chip class="selected" style="height: auto"
            >{{ tConv24(item.startTime) }} - {{ tConv24(item.endTime) }}
          </mat-chip>
        </div>
      </mat-chip-list>
    </div>
    <button
      class="add-new-btn"
      (click)="openTimings()"
      mat-flat-button
      color="accent"
    >
      <mat-icon>add</mat-icon>
      Add another day
    </button>
  </div>
 
</mat-dialog-content>

<mat-dialog-actions align="end" *ngIf="editmode">
  <button mat-button mat-dialog-close>Cancel</button>
  <button
    mat-flat-button
    color="accent"
    [disabled]="
      selectedDaysChecker()
    "
    (click)="onPost()"
  >
    Confirm
  </button>
</mat-dialog-actions>
